import type { Asset } from '@rover/types/src/ImagePicker';

import {
  IMAGE_ACCEPT_STRING,
  IMAGE_AND_VIDEO_ACCEPT_STRING,
  VIDEO_ACCEPT_STRING,
} from './constants';
import MediaFile from './MediaFile';
import { FileInputAcceptStrings, MediaType, SelectMediaHookAPI, SelectMediaOptions } from './types';

export const filesToMediaFiles = (files: FileList | Asset[]): MediaFile[] =>
  Array.from(files, (file) => new MediaFile(file));

export const getSelectMediaInputProps = ({
  type,
  multiple,
}: SelectMediaOptions): Omit<SelectMediaHookAPI['inputProps'], 'onChange'> => {
  let accept: FileInputAcceptStrings;
  if (type) {
    accept = type === MediaType.IMAGE ? IMAGE_ACCEPT_STRING : VIDEO_ACCEPT_STRING;
  } else {
    accept = IMAGE_AND_VIDEO_ACCEPT_STRING;
  }
  return {
    type: 'file',
    multiple: multiple || false,
    accept,
  };
};

export function getSelectMediaDropzoneProps(
  opts: SelectMediaOptions
): Omit<SelectMediaHookAPI['dropzoneProps'], 'onDrop'> {
  // The below is an ok way of cloning an object while omitting some props
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { type, ...other } = getSelectMediaInputProps(opts);
  return other;
}
